<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-if="readonly"
          name="date_from"
          :value="form.date_from | dateFormat"
          :label="`${$t('ITEM.DATE')} *`"
          :error-messages="errors.date_from"
          prepend-inner-icon="mdi-calendar"
          readonly
        ></v-text-field>

        <v-menu
          v-else
          ref="menuDateFrom"
          min-width="290px"
          transition="scale-transition"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              name="date_from"
              autocomplete="nope"
              prepend-inner-icon="mdi-calendar"
              :value="form.date_from | dateFormat"
              :label="`${$t('ITEM.DATE')} *`"
              :readonly="readonly"
              :rules="getRulesByName('date_from')"
              :error-messages="errors.date_from"
              clearable
              v-bind="attrs"
              v-on="on"
              @click:clear="form.date_from = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="form.date_from"
            first-day-of-week="1"
            @change="setDateFrom"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-if="readonly"
          name="time_from"
          :value="form.time_from"
          :label="`${$t('ITEM.TIME_FROM')} *`"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="getRulesByName('time_from')"
          :error-messages="errors.time_from"
          readonly
        />

        <v-menu
          v-else
          ref="timeFrom"
          v-model="timeFrom"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="form.time_from"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="form.time_from"
              name="time_from"
              :label="`${$t('ITEM.TIME_FROM')} *`"
              prepend-icon="mdi-clock-time-four-outline"
              :clearable="!readonly"
              readonly
              :rules="getRulesByName('time_from')"
              :error-messages="errors.time_from"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-time-picker
            v-if="timeFrom"
            v-model="form.time_from"
            :allowed-minutes="allowedStep"
            :max="form.time_to"
            :readonly="readonly"
            format="24hr"
            scrollable
            v-on="
              step === 60
                ? {
                    'click:hour': v => $refs.timeFrom.save(hourDateFormatted(v))
                  }
                : {
                    'click:minute': v => $refs.timeFrom.save(form.time_from)
                  }
            "
            @input="updateValue('time_from', $event)"
          />
        </v-menu>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-if="readonly"
          name="time_to"
          :value="form.time_to"
          :label="`${$t('ITEM.TIME_TO')} *`"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="getRulesByName('time_to')"
          :error-messages="errors.time_to"
          readonly
        />

        <v-menu
          v-else
          ref="timeTo"
          v-model="timeTo"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="form.time_to"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="form.time_to"
              name="time_to"
              prepend-icon="mdi-clock-time-four-outline"
              :label="`${$t('ITEM.TIME_TO')} *`"
              :rules="getRulesByName('time_to')"
              :error-messages="errors.time_to"
              :clearable="!readonly"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-time-picker
            v-if="timeTo"
            v-model="form.time_to"
            :allowed-minutes="allowedStep"
            format="24hr"
            :min="form.time_from"
            :readonly="readonly"
            scrollable
            v-on="
              step === 60
                ? {
                    'click:hour': v => $refs.timeTo.save(hourDateFormatted(v))
                  }
                : {
                    'click:minute': v => $refs.timeTo.save(form.time_to)
                  }
            "
            @input="updateValue('time_to', $event)"
          />
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { dateFormat } from '@/modules/_global/filters';
import { notEmpty } from '@/modules/_global/variables/rules';
import moment from 'moment';

export default {
  name: 'BookingReservationHourForm',

  filters: {
    dateFormat
  },

  mixins: [formEditable],

  props: {
    step: {
      type: Number,
      default: 5
    }
  },

  data() {
    return {
      form: {
        time_from: null,
        time_to: null
      },
      rules: {
        date_from: [notEmpty],
        time_from: [notEmpty],
        time_to: [notEmpty]
      },
      timeFrom: false,
      timeTo: false
    };
  },

  computed: {
    listeners: function() {
      return 0;
    }
  },

  methods: {
    setDateFrom(date) {
      this.$refs.menuDateFrom.save(date);
      this.updateValue('date_from', date);
    },

    allowedStep(m) {
      return m % this.step === 0;
    },
    hourDateFormatted(value) {
      if (!value) return '';

      return moment(value, ['HH']).format('HH:mm');
    }
  }
};
</script>
